import WasteProcessedPanel from 'src/components/material/DeviceDashboard/WasteProcessed/WasteProcessedPanel'
import React from 'react'
import { useSelector } from 'react-redux';
import { selectCyclesByFacilities } from '../summaryDashboardSlice';

const WasteProcessedContainer = () => {
    const {
        userTimezone,
        weightUnit,
        selectedFacilities,
    } = useSelector(
        // @ts-ignore
        (store) => store.summarydashboard
    );

    const filteredCycles = useSelector((store) => selectCyclesByFacilities(store.summarydashboard, selectedFacilities.map(facility => facility.name)));

    const loading = useSelector((store) => store.summarydashboard.loading.wasteProcessed);

    return (
        <WasteProcessedPanel deviceCycles={filteredCycles} userTimezone={userTimezone} weightUnit={weightUnit} loading={loading} />
    )
}

export default WasteProcessedContainer
